
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"8","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.454.084l-.357 3.279L8.4 2.44l.216 1.511-3.162.257 2.058 2.707-1.428.78-1.46-3.005-1.329 3.005-1.46-.78 2.008-2.707-3.13-.257.242-1.51 3.245.92L3.843.085h1.61z"}})])
          )
        }
      }
    